import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Modal from "../../components/modal";
import { useStoreActions, useStoreState } from "easy-peasy";
import moment from "moment";
import { Icon } from "@mui/material";
import { deleteLateReadingCall } from "api/api";
import { CheckPermissionRender } from "helpers/checkPermission";
import permissions from "../../config/permissions";

export default function LateReadingsPopup({ reload }) {
  const lateReadings = useStoreState((state) => state.lateReadings);
  const setLateReadings = useStoreActions((actions) => actions.setLateReadings);

  const onClose = () => {
    setLateReadings(null);
  };

  const onDelete = (id) => {
    global.showConfDialog(
      "Are you sure?",
      <span>This action will delete the late reading date</span>,
      async () => {
        await deleteLateReadingCall(id);
        onClose();
        reload();
      },
      ["Confirm", "Cancel"]
    );
  };

  if (!lateReadings) {
    return null;
  }
  return (
    <Modal
      open={lateReadings.length > 0}
      title={"Late Readings"}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onClose} variant="gradient" color="error">
            close
          </MDButton>
        </MDBox>
      }
    >
      {lateReadings.map((lateReading) => (
        <div
          key={lateReading.id}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            borderBottom: "1px solid gray",
          }}
        >
          <div>{moment(lateReading.late_reading_date).format("YYYY-MM-DD")}</div>
          <CheckPermissionRender permissions={permissions().account().update().list()}>
            <MDButton onClick={() => onDelete(lateReading.id)}>
              <Icon fontSize="large" color="error">
                delete
              </Icon>
            </MDButton>
          </CheckPermissionRender>
        </div>
      ))}
    </Modal>
  );
}
